<template>
  <PageShell active="about">
    <section :class="['help-page', { 'faq-active': selectedFaq }]">
      <aside class="faq-nav" aria-label="Frequently asked questions">
        <button v-for="(faq, index) in faqs" :key="faq.id || index" type="button"
          :class="['faq-nav-item', { active: selectedFaq === faq }]" @click="selectFaq(faq)">
          {{ faq.title || faq.question }}
        </button>
      </aside>

      <aside v-if="!selectedFaq" class="help-nav" aria-label="Help sections">
        <div class="breadcrumb">
          <i class="el-icon-s-home"></i>
          <i class="el-icon-right"></i>
          <span>Help</span>
        </div>
        <a v-for="(article, index) in articles" :key="article.id || index" :href="`#${articleAnchor(article, index)}`"
          @click.prevent="scrollTo(articleAnchor(article, index))">{{ article.title }}</a>
      </aside>

      <main v-loading="loading" :class="['help-content', { 'faq-content': selectedFaq }]">
        <article v-if="selectedFaq" class="help-article faq-answer">
          <nav class="faq-breadcrumb" aria-label="Breadcrumb">
            <i class="el-icon-s-home"></i>
            <i class="el-icon-right"></i>
            <button type="button" @click="returnToHelp">Help</button>
            <i class="el-icon-right"></i>
            <span>{{ selectedFaq.title || selectedFaq.question }}</span>
          </nav>
          <h1>{{ selectedFaq.title || selectedFaq.question }}</h1>
          <div class="article-content" v-html="selectedFaq.answer"></div>
        </article>
        <article v-for="(article, index) in articles" v-else :id="articleAnchor(article, index)"
          :key="article.id || index" class="help-article">
          <h1>{{ article.title }}</h1>
          <div class="article-content" v-html="article.content"></div>
        </article>
      </main>

      <aside v-if="!selectedFaq" class="order-process" aria-label="Order process">
        <h2>Order Process</h2>
        <div class="process-step">Parts Inquiry</div>
        <img class="process-arrow" src="@/assets/jiantou.png" alt="">
        <div class="process-step">Availability Check</div>
        <img class="process-arrow" src="@/assets/jiantou.png" alt="">
        <div class="process-step">Payment</div>
        <img class="process-arrow" src="@/assets/jiantou.png" alt="">
        <div class="process-step">Pay shipping fee</div>
        <img class="process-arrow" src="@/assets/jiantou.png" alt="">
        <div class="process-step">Shipping and Delivery</div>
      </aside>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'

export default {
  name: 'HelpPage',
  components: { PageShell },
  data() {
    return {
      articles: [],
      faqs: [],
      selectedFaq: null,
      loading: false
    }
  },
  mounted() {
    this.loadArticles()
    this.loadFaqs()
  },
  methods: {
    async loadArticles() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Content/article',
          method: 'get',
          data: { category: 'help' }
        })
        this.articles = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        this.articles = []
      } finally {
        this.loading = false
      }
    },
    async loadFaqs() {
      let that=this
      try {
        const res = await this.$api({
          url: 'Content/faqs',
          method: 'get'
        })
        this.faqs = Array.isArray(res.data) ? res.data : []
        res.data.forEach((e)=>{
          if(e.id==this.$route.query.id){
            that.selectFaq(e)
          }
        })
      } catch (e) {
        this.faqs = []
      }
    },
    articleAnchor(article, index) {
      return `help-article-${article.id || index}`
    },
    selectFaq(faq) {
      console.log('faq',faq)
      this.selectedFaq = faq
      this.$nextTick(() => {
        const content = document.querySelector('.help-content')
        if (content) content.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
    returnToHelp() {
      this.selectedFaq = null
      this.$nextTick(() => {
        const page = document.querySelector('.help-page')
        if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
    scrollTo(id) {
      this.selectedFaq = null
      this.$nextTick(() => {
        const target = document.getElementById(id)
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
  }
}
</script>

<style scoped>
.help-page {
  width: 1100px;
  min-height: 2100px;
  margin: 0 auto;
  padding: 15px 0 70px;
  display: grid;
  grid-template-columns: 190px minmax(0, 850px) 250px;
  align-items: start;
  align-content: start;
  column-gap: 40px;
  row-gap: 34px;
}

.help-nav {
  grid-column: 2 / -1;
  color: #f34b01;
  font-size: 14px;
  line-height: 1.35;
}

.faq-nav {
  grid-column: 1;
  grid-row: 1;
  width: 190px;
  padding-top: 35px;
  color: #f34b01;
  font-size: 14px;
  line-height: 1.35;
}

.faq-nav-item {
  display: block;
  width: 100%;
  margin-bottom: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #f34b01;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.35;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.faq-nav-item.active,
.faq-nav-item:hover {
  color: #d94100;
}

.help-content {
  grid-column: 2;
  grid-row: 2;
}

.help-page.faq-active {
  min-height: 650px;
}

.help-content.faq-content {
  grid-column: 2 / -1;
  grid-row: 1;
}

.faq-breadcrumb {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #333;
  font-size: 14px;
  line-height: 1.35;
  margin-bottom: 19px;
}

.faq-breadcrumb .el-icon-s-home,
.faq-breadcrumb button {
  color: #f34b01;
}

.faq-breadcrumb .el-icon-arrow-right {
  color: #aaa;
  font-size: 15px;
}

.faq-breadcrumb button {
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.35;
}

.faq-breadcrumb button:hover {
  color: #d94100;
}

.faq-breadcrumb span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.faq-breadcrumb+h1 {
  margin-top: 28px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 19px;
  color: #333;
  font-size: 12px;
}

.breadcrumb :first-child {
  color: #f34b01;
}

.help-nav a {
  margin-left: 20px;
  display: block;
  width: fit-content;
  margin-bottom: 18px;
  border: 0;
  color: #f34b01;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.35;
}

.help-article {
  scroll-margin-top: 22px;
}

.help-article+.help-article {
  margin-top: 55px;
}

.help-article h1 {
  margin: 0;
  color: #222;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.25;
}

.article-content {
  margin-top: 27px;
  color: #222;
  font-size: 14px;
  line-height: 1.48;
}

.article-content ::v-deep p {
  margin: 0 0 18px;
}

.article-content ::v-deep h1,
.article-content ::v-deep h2,
.article-content ::v-deep h3,
.article-content ::v-deep h4 {
  margin: 26px 0 19px;
  color: #222;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.35;
}

.article-content ::v-deep ul,
.article-content ::v-deep ol {
  margin: 0 0 18px 22px;
  padding: 0;
  list-style: initial;
}

.article-content ::v-deep img {
  max-width: 100%;
  height: auto;
}

.order-process {
  grid-column: 3;
  grid-row: 2;
  width: 250px;
  margin-top: 60px;
  padding: 30px 24px 32px;
  border: 1px solid #d6d6d6;
  color: #222;
  text-align: center;
}

.order-process h2 {
  margin: 0 0 28px;
  font-size: 20px;
  font-weight: 700;
  text-align: left;
}

.process-step {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
}

.process-arrow {
  display: block;
  width: 30px;
  height: 47px;
  margin: 9px auto;
  object-fit: contain;
}

@media (max-width: 1000px) {
  .help-page {
    grid-template-columns: 150px minmax(0, 1fr);
    min-height: auto;
  }

  .faq-nav {
    grid-column: 1;
  }

  .help-nav {
    grid-column: 2;
  }

  .help-content {
    grid-column: 2;
  }

  .help-content.faq-content {
    grid-column: 2;
    grid-row: 1;
  }

  .order-process {
    display: none;
  }
}

@media (max-width: 650px) {
  .help-page {
    display: block;
    padding-top: 24px;
  }

  .help-nav {
    margin-bottom: 28px;
  }

  .faq-nav {
    margin-bottom: 28px;
    padding-top: 0;
  }

  .help-article h1 {
    font-size: 25px;
  }

  .article-content {
    font-size: 15px;
  }
}
</style>
